var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodafoneColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31394 0.69882C8.82892 -0.300719 11.7585 -0.23161 14.2064 0.929341C13.5088 0.82367 12.7994 0.903346 12.1089 1.01974C10.2337 1.37289 8.4516 2.25271 7.05865 3.5598C5.72304 4.8689 4.78709 6.60587 4.52274 8.46419C4.34789 9.78095 4.50997 11.1621 5.10252 12.3606C5.71313 13.6181 6.78795 14.6494 8.0834 15.1817C9.3317 15.7084 10.7797 15.7026 12.0441 15.2325C13.9413 14.5382 15.3044 12.6636 15.4603 10.6608C15.5583 9.34813 15.2382 7.95174 14.3538 6.94496C13.5095 5.95948 12.2747 5.41665 11.039 5.10767C10.9728 3.89245 11.5469 2.69193 12.4574 1.90162C12.9631 1.44697 13.5906 1.15717 14.2395 0.971715L14.2888 0.954755C16.1464 1.84302 17.7248 3.30799 18.7305 5.10645C19.5921 6.63762 20.0415 8.40206 19.997 10.1596C19.9885 12.4324 19.1365 14.6826 17.6761 16.4205C16.2952 18.0777 14.3637 19.2699 12.2585 19.7472C10.1478 20.2328 7.87686 20.0234 5.90144 19.1288C3.96851 18.268 2.33093 16.7715 1.28917 14.9307C0.422582 13.401 -0.0358525 11.6372 0.0021914 9.87754C0.00632431 7.68508 0.787073 5.50953 2.15024 3.79508C3.23911 2.42611 4.68361 1.3376 6.31394 0.69882Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafoneColored);
export default __webpack_public_path__ + "static/media/VodafoneColored.7b0b2467e6fbea62839a248e5b019b67.svg";
export { ForwardRef as ReactComponent };